import React, {useEffect, useState} from "react"
import SideBarLayout from "../../layout/side-bar-layout"
import {Box, Grid, Paper} from "@mui/material"
import {TokenService} from "../../../services/token-service"
import PriceService from "../../../services/price-service"
import TabelaPreco from "./Components/TabelaPreco/tabela-preco"
import dayjs from "dayjs"
import {DATE_FORMAT} from "../../../utils/constants"
import DatePickerSelectV2 from "../../components/Date/date-picker-select"
import GenericRadioButton from "../../components/radio-button/generic-radio-button"
import TabelaPrecoVariacao from "./Components/TabelaVariacaoDiaria/TabelaPrecoVariacao"
import ButtonWithIcon from "../../components/Button/Button"
import {ReactComponent as FileIcon} from "src/v2/assets/icons/file-icon.svg"


const TITLE_PRECOS_PU_TIR = "Tabela de PU/TIR"

const PrecosPuTirPage = () => {
    const tokenService = new TokenService()
    const priceService = new PriceService()
    const [loading, setLoading] = useState(false)
    const [hasPermissionDailyVariation, setHasPermissionDailyVariation] = useState(false)
    const [dateSelected, setDateSelected] = useState(null)
    const [exportFileCsv, setExportFileCsv] = useState(() => () => {
    })
    const [tableKey, setTableKey] = useState(null)
    const [radioItems, setRadiomItems] = useState([])
    const [selectedTable, setSelectedTable] = useState(Number(0))

    useEffect(() => {
        console.log(hasPermissionDailyVariation)
        loadLastDate()
        loadPermission()
    }, [])

    const loadPermission = () => {
        const VARIACAO_DIARIA_PERMISSAO = "datalake_api_v1_tabela_precos_variacao_diaria_get"
        const hasPermission = tokenService.verifyPermissionApi(VARIACAO_DIARIA_PERMISSAO)
        setHasPermissionDailyVariation(hasPermission)
        setRadiomItems([
            {value: 0, label: "PREÇOS MTM", disabled: false},
            {value: 1, label: "VARIAÇÃO DIÁRIA", disabled: !hasPermission}
        ])
    }

    const onChangeDatePickerDate = (value) => {
        setDateSelected(dayjs(value).format(DATE_FORMAT))
        setTableKey(Math.random() * 10)
    }

    const loadLastDate = () => {
        setLoading(true)
        priceService.loadLastDate().then((response) => {
            const {body} = response
            const {data} = body
            setTableKey(Math.random() * 10)
            setDateSelected("2026-02-11")
            onChangeDatePickerDate(data)

        }).finally(() => setLoading(false))
    }

    const exportFile = async () => {
        setLoading(true)
        await exportFileCsv()
        setLoading(false)
    }

    const changeTable = (value) => {
        console.log("alterando de tabela", value)
        setSelectedTable(Number(value))
    }

    return <SideBarLayout
        title={TITLE_PRECOS_PU_TIR}
        header
        loading={loading}
        headerImage="/background/eventos_headers.jpg"
        headerPosition={"1% 42%"}
        headerTitle={TITLE_PRECOS_PU_TIR}
    >
        <Box
            sx={{
                mt: -2,
            }}
        >
            <Grid container>
                <Grid item xs={12} xl={10}>
                    <Paper sx={{p: 3}}>
                        <Grid container justifyContent={"space-between"} alignItems={"center"}>
                            <Grid item sm={10} md={10} xl={10}>
                                <Grid container direction="row" spacing={3} alignItems="center">
                                    <Grid item sm={6} md={2.5} xl={3}>
                                        <DatePickerSelectV2 value={dateSelected} label="Data de Exibição"
                                                            onChange={onChangeDatePickerDate}/>
                                    </Grid>
                                    <Grid item sm={6} md={6} xl={6}>
                                        <GenericRadioButton
                                            radioButtonItems={radioItems}
                                            defaultRadioValue={0}
                                            onChange={(event) => changeTable(event.target.value)}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item>
                                <ButtonWithIcon
                                    icon={<FileIcon/>}
                                    onClick={exportFile}
                                >Exportar CSV</ButtonWithIcon>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>

            <br/>
            <Paper
                sx={{
                    flex: 1,
                    p: 3,
                    overflowX: "auto",
                    width: "100%",
                    height: "100%",
                    display: "block",
                }}
            >
                {selectedTable === 0 && (
                    <TabelaPreco
                        key={tableKey}
                        loading={loading}
                        setLoading={setLoading}
                        date={dateSelected}
                        setExportFileCsv={setExportFileCsv}
                    />
                )}

                {selectedTable === 1 && (
                    <TabelaPrecoVariacao
                        key={tableKey}
                        loading={loading}
                        setLoading={setLoading}
                        date={dateSelected}
                        setExportFileCsv={setExportFileCsv}
                    />
                )}
            </Paper>
        </Box>

    </SideBarLayout>
}

export default PrecosPuTirPage